module.exports = __webpack_public_path__ + "static/media/Agri-Transporter Infographic Desktop - GBR Tech - 24-05-204 C.c60e07cc.gif";